module.exports = __webpack_public_path__ + "media/yolo-3.0/check-circle-regular-3140352a.svg";